module.exports = __webpack_public_path__ + "57d566ecefc1f2aa28943ca92811ed3a.otf";


//////////////////
// WEBPACK FOOTER
// ./src/client/fonts/Interstate-Regular.otf
// module id = 968
// module chunks = 0